import React from "react";
import Team from "../Componant-team/Team";
import Contact from "../Componant-contact/Contact";

export default function TF() {
  return (
    <>
      <Team />
      <Contact />
    </>
  );
}
